var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ol",
    { staticClass: "breadcrumbs" },
    [
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: { name: "dashboard" } } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/apps_logo.svg"),
                alt: _vm.$t("title")
              }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.visibleLinks, function(link) {
        return _c(
          "li",
          [
            typeof link === "object"
              ? _c("router-link", { attrs: { to: link } }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm._f("text")(link.title || "")) +
                      "\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            typeof link === "string"
              ? _c("span", [
                  _vm._v("\n      " + _vm._s(_vm._f("text")(link)) + "\n    ")
                ])
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("li", { ref: "toprightmenu", staticClass: "user" }, [
        _c(
          "a",
          {
            on: {
              click: function($event) {
                _vm.menuopen = !_vm.menuopen
              }
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm._f("text")(_vm.user)))]),
            _vm._v(" "),
            _vm.admintoken
              ? _c("small", [
                  _vm._v(
                    "\n        (" +
                      _vm._s(_vm._f("trans")("apptokens:admin.as")) +
                      "\n        " +
                      _vm._s(_vm._f("text")(_vm.admintoken.company_name)) +
                      ")\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("Icon", { attrs: { name: "cog" } })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "nav",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.menuopen,
                expression: "menuopen"
              }
            ]
          },
          [
            _c("span", [_c("languages")], 1),
            _vm._v(" "),
            _vm.$store.getters.admin
              ? _c(
                  "router-link",
                  {
                    attrs: { to: { name: "apptokens.select" } },
                    nativeOn: {
                      click: function($event) {
                        return _vm.clicked($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("trans")("apptokens:admin.choose")) +
                        "\n      "
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    attrs: { href: _vm.accountlink },
                    on: { click: _vm.clicked }
                  },
                  [_vm._v(_vm._s(_vm._f("trans")("titles.profile")))]
                ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                attrs: { to: { name: "apptokens.edit" } },
                nativeOn: {
                  click: function($event) {
                    return _vm.clicked($event)
                  }
                }
              },
              [_vm._v(_vm._s(_vm._f("trans")("titles.apptokens")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { href: _vm.toslink, target: "_blank" },
                on: { click: _vm.clicked }
              },
              [_vm._v(_vm._s(_vm._f("trans")("terms")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "left", 37, $event.key, [
                        "Left",
                        "ArrowLeft"
                      ])
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 0) {
                      return null
                    }
                    return _vm.logout($event)
                  }
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.clicked($event)
                  }
                }
              },
              [_vm._v(_vm._s(_vm._f("trans")("logout")))]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ca01967", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ca01967","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Breadcrumbs.vue
// module id = null
// module chunks = 